export const VARIANT_BILLING_TYPE = Object.freeze({
  ONE_TIME: 'one_time',
  RECURRING: 'recurring',
  PAY_WHAT_YOU_WANT: 'pay_what_you_want',
});
